export const GET_ALL_COUNTRIES = "GET_ALL_COUNTRIES";
export const GET_ALL_COUNTRIES_SUCCESS = "GET_ALL_COUNTRIES_SUCCESS";
export const GET_ALL_COUNTRIES_FAILURE = "GET_ALL_COUNTRIES_FAILURE";

export const GET_ALL_CURRENCIES = "GET_ALL_CURRENCIES";
export const GET_ALL_CURRENCIES_SUCCESS = "GET_ALL_CURRENCIES_SUCCESS";
export const GET_ALL_CURRENCIES_FAILURE = "GET_ALL_CURRENCIES_FAILURE";

export const GET_ALL_CITIES = "GET_ALL_CITIES";
export const GET_ALL_CITIES_SUCCESS = "GET_ALL_CITIES_SUCCESS";
export const GET_ALL_CITIES_FAILURE = "GET_ALL_CITIES_FAILURE";

export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const GET_ALL_ROLES_SUCCESS = "GET_ALL_ROLES_SUCCESS";
export const GET_ALL_ROLES_FAILURE = "GET_ALL_ROLES_FAILURE";
